module.exports = __webpack_public_path__ + "media/images/flags/16/Micronesia-7ac51e86c98b677f11538dc0bfe8a592.png";